const LS_PROJECT = "content_projectId";
const LS_VERSION = "content_versionId";

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function sanitizeContentId(value) {
    if (typeof value !== "string") return null;
    const normalized = value.trim();
    return UUID_RE.test(normalized) ? normalized : null;
}

function readStoredScope() {
    if (typeof window === "undefined" || !window.localStorage) {
        return { projectId: null, versionId: null };
    }

    return {
        projectId: sanitizeContentId(window.localStorage.getItem(LS_PROJECT)),
        versionId: sanitizeContentId(window.localStorage.getItem(LS_VERSION)),
    };
}

function ensureScope(projectId, versionId) {
    if (!projectId || !versionId) {
        throw new Error("Не выбран проект или версия контента");
    }
}

export function resolveContentScope(projectId, versionId) {
    const stored = readStoredScope();
    return {
        projectId: projectId ?? stored.projectId,
        versionId: versionId ?? stored.versionId,
    };
}

export function resolveScopedListArgs(args = {}, init) {
    const { projectId, versionId } = resolveContentScope(args?.projectId, args?.versionId);
    ensureScope(projectId, versionId);
    return {
        args: {
            ...args,
            projectId,
            versionId,
        },
        init,
    };
}

export function resolveScopedIdArgs(projectId, versionId, id, init) {
    if (typeof id !== "undefined") {
        const scope = resolveContentScope(projectId, versionId);
        ensureScope(scope.projectId, scope.versionId);
        return {
            ...scope,
            id,
            init,
        };
    }

    const scope = resolveContentScope();
    ensureScope(scope.projectId, scope.versionId);
    return {
        ...scope,
        id: projectId,
        init: versionId,
    };
}

export function resolveScopedPayloadArgs(projectId, versionId, payload, init) {
    if (typeof payload !== "undefined") {
        const scope = resolveContentScope(projectId, versionId);
        ensureScope(scope.projectId, scope.versionId);
        return {
            ...scope,
            payload,
            init,
        };
    }

    const scope = resolveContentScope();
    ensureScope(scope.projectId, scope.versionId);
    return {
        ...scope,
        payload: projectId,
        init: versionId,
    };
}

export function resolveScopedMutationArgs(projectId, versionId, id, payload, init) {
    if (typeof payload !== "undefined") {
        const scope = resolveContentScope(projectId, versionId);
        ensureScope(scope.projectId, scope.versionId);
        return {
            ...scope,
            id,
            payload,
            init,
        };
    }

    const scope = resolveContentScope();
    ensureScope(scope.projectId, scope.versionId);
    return {
        ...scope,
        id: projectId,
        payload: versionId,
        init: id,
    };
}

export function resolveScopedRenameArgs(projectId, versionId, id, newSystemName, init) {
    if (typeof newSystemName !== "undefined") {
        const scope = resolveContentScope(projectId, versionId);
        ensureScope(scope.projectId, scope.versionId);
        return {
            ...scope,
            id,
            newSystemName,
            init,
        };
    }

    const scope = resolveContentScope();
    ensureScope(scope.projectId, scope.versionId);
    return {
        ...scope,
        id: projectId,
        newSystemName: versionId,
        init: id,
    };
}

export function resolveScopedLinkArgs(projectId, versionId, id, linkId, init) {
    if (typeof linkId !== "undefined") {
        const scope = resolveContentScope(projectId, versionId);
        ensureScope(scope.projectId, scope.versionId);
        return {
            ...scope,
            id,
            linkId,
            init,
        };
    }

    const scope = resolveContentScope();
    ensureScope(scope.projectId, scope.versionId);
    return {
        ...scope,
        id: projectId,
        linkId: versionId,
        init: id,
    };
}

export function resolveScopedLinkPayloadArgs(projectId, versionId, id, linkId, payload, init) {
    if (typeof payload !== "undefined") {
        const scope = resolveContentScope(projectId, versionId);
        ensureScope(scope.projectId, scope.versionId);
        return {
            ...scope,
            id,
            linkId,
            payload,
            init,
        };
    }

    const scope = resolveContentScope();
    ensureScope(scope.projectId, scope.versionId);
    return {
        ...scope,
        id: projectId,
        linkId: versionId,
        payload: id,
        init: linkId,
    };
}

export function resolveScopedValueArgs(projectId, versionId, id, parameterId, payload, init) {
    if (typeof payload !== "undefined") {
        const scope = resolveContentScope(projectId, versionId);
        ensureScope(scope.projectId, scope.versionId);
        return {
            ...scope,
            id,
            parameterId,
            payload,
            init,
        };
    }

    const scope = resolveContentScope();
    ensureScope(scope.projectId, scope.versionId);
    return {
        ...scope,
        id: projectId,
        parameterId: versionId,
        payload: id,
        init: parameterId,
    };
}
